import React from "react";
import { Button, ButtonSize, ButtonVariant } from "@wattpad/web-ui-library";
import { useTrans } from "../../../hooks";
import PropTypes from "prop-types";

const ButtonLabel = ({ action }) => {
  const { trans } = useTrans();

  return action === "login"
    ? trans("Log in with email")
    : trans("Sign up with email");
};

export const WattpadEmailAuthenticationButton = ({
  action,
  handleClick = () => {}
}) => {
  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      size={ButtonSize.MEDIUM}
      fullWidth
      onClick={handleClick}
      label={<ButtonLabel action={action} />}
    />
  );
};

WattpadEmailAuthenticationButton.propTypes = {
  action: PropTypes.oneOf(["login", "signup"]),
  handleClick: PropTypes.func
};
